import { Flex, Spinner } from "@hcsc-fiber/react";
import React from "react";
type loaderProps = {
  size: "small" | "medium" | "large";
};
export const Loader = (props: loaderProps) => {
  return (
    <Flex direction={"row"} justifyContent={"center"} alignItems={"center"}>
      <Spinner size={props.size} />
    </Flex>
  );
};
